import { render } from "./ReturnChart.vue?vue&type=template&id=33f61405&scoped=true&ts=true"
import script from "./ReturnChart.vue?vue&type=script&lang=ts"
export * from "./ReturnChart.vue?vue&type=script&lang=ts"

import "./ReturnChart.vue?vue&type=style&index=0&id=33f61405&scoped=true&lang=scss"

import exportComponent from "/builds/gh_devops/fund_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f61405"]])

export default __exports__